module.exports = __webpack_public_path__ + "static/media/united-nations-covid-19-response.9038eb7a.jpg";